import {useEffect} from 'react';

import { Link } from 'react-router-dom';
import AirTicketing from './AirTicketing';
import BusinessTravel from './BusinessTravel';
import DomesticInternationalTours from './DomesticInternationalTours';
import LeisureTravel from './LeisureTravel';
import UmrahPackages from './UmrahPackages';


const IntianaTravelTours = () => {
    useEffect(()=>{
        let current_page = window.location.href.split('/').at(-1)
        setTimeout(()=>{
            document.getElementById(`${current_page}`)?.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }, 100)
    })
    window.addEventListener("scroll", function(event) {
        let top = this.scrollY,
            window_width = window.innerWidth,
            header_height = document.querySelector("header").style.height+100;
            // (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
            (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
    }, false);  
    window.addEventListener("scroll", function(event) {
        let top = this.scrollY,
            window_width = window.innerWidth,
            header_height = document.querySelector("header").style.height+100;
            (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
            // (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
    }, false);  
  
    return(
        <div>
            <div id='international' className="intiana-image">
                <img src='/Intiana/main-banner.jpg' alt='' className='w-[100%]'/>
            </div>
            <div className="flex flex-col justify-center gap-4 max-w-[50rem] lg:mx-auto md:mx-auto mx-[2rem]  md:p-[2rem] pt-[1rem] lg:pb-[50px]  pb-[1rem]">
                <p>
                    Commencing operations in 2004, TCS Travel & Tours strives to be the preferred travel services 
                    company for its customers, with passion and professionalism. It provides one-stop travel solutions, 
                    whether it is business, leisure, group tours or cruises to exotic destinations and religious 
                    pilgrimages. TCS Travel & Tours provides a wide variety of international and domestic travel 
                    and tour related services, on all major domestic and international carriers.
                </p>
                
                
                <div className="MuiFormGroup-root MuiFormGroup-row">
                    <div className="md:flex grid pb-[50px]">
                        <div className="flex-1 flex flex-col">
                            <div className="flex items-center ">
                                <li><Link to="/intiana-travel/umrah-packages"  className='font-bold'>Umrah Packages</Link></li>
                            </div>
                            <div className="flex items-center">
                                <li><Link to="/intiana-travel/Business-travel" className='font-bold'>Business Travel</Link></li>
                            </div>

                            <div className="flex items-center">
                                <li><Link to="/intiana-travel/leisure-travel" className='font-bold'>Leisure Travel</Link></li>
                            </div>
                        </div>

                        <div className="flex-1 flex flex-col">
                            <div className="flex items-center">
                                <li><Link to="/intiana-travel/domestic-int-tours" className='font-bold'>Domestic and International Tours</Link></li>
                            </div>
                            <div className="flex items-center">
                                <li><Link to="/intiana-travel/air-ticketing" className='font-bold'>Air Ticketing</Link></li>
                            </div>
                           
                        </div>
                        
                            
                    </div>
                </div>
               
                 
            </div>
            
            <div className='mx-[2rem] md:mx-[0rem]'>
            <div id="umrah-packages">
                <UmrahPackages />
            </div>
            <div id="Business-travel">
                < BusinessTravel/>
            </div>
            <div id="leisure-travel">
                <LeisureTravel />
            </div>
            <div id="domestic-int-tours">
            <DomesticInternationalTours />
            </div>
            <div id="air-ticketing">
            <AirTicketing/>
            </div>
            </div>
        </div>
    )
};
export default IntianaTravelTours;